import { createSelector } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
dayjs.extend(customParseFormat);

/*eslint-disable*/
//todo remove getUser selector after refactoring user reducer
export const getUsers = createSelector(
    ({ user }) => {
        return user.users ? user.users.list : [];
    },
    (users) => {
        return users.map((u) => ({
            ...u,
            fullName: `${u.lastName} ${u.firstName}`,
            ...getFormattedDates(u),
        }));
    },
);

const getFormattedDates = (user) => {
    return {
        hireDate: dayjs(user.hireDate).format('DD.MM.YYYY'),
        dayOfBirth: user.dayOfBirth ? dayjs(user.dayOfBirth) : null,
    };
};

export const reselectUsers = createSelector(
    ({ users }) => users.list,
    (users) =>
        users.map((u) => ({
            ...u,
            fullName: `${u.lastName} ${u.firstName}`,
            ...getFormattedDates(u),
        })),
);

export const getUserId = ({ user }) => user.user.id;
export const getToken = ({ user }) => user.token;
